export default __webpack_public_path__ + "static/media/future-sound-mockup1.82b0127a.png";